// toastUtils.tsx
import React from "react";
import { toast, ToastOptions } from "react-hot-toast";

export const showToast = {
  default: (message: string, options?: ToastOptions) => {
    toast.custom((t) => (
      <div
        onClick={() => toast.dismiss(t.id)}
        style={{
          background: "#363636",
          color: "#fff",
          padding: "12px 20px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        {message}
      </div>
    ), options);
  },
  loading: (message: string, options?: ToastOptions) => {
    toast.loading(
      <div
        onClick={() => toast.dismiss()}
        style={{ cursor: "pointer" }}
      >
        {message}
      </div>,
      options
    );
  },
  dismiss: (id?: string | number) => {
    toast.dismiss(id?.toString());
  },
  success: (message: string, options?: ToastOptions) => {
    toast.success(
      <div
        onClick={() => toast.dismiss()}
        style={{ cursor: "pointer" }}
      >
        {message}
      </div>,
      options
    );
  },
  error: (message: string, options?: ToastOptions) => {
    toast.error(
      <div
        onClick={() => toast.dismiss()}
        style={{ cursor: "pointer" }}
      >
        {message}
      </div>,
      options
    );
  }
};

export default showToast;
